import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import loginPageReducer from './LoginPage';
import signUpPageReducer from './SignUpPage';
import applicationInfoPageReducer from './ApplicationPage/ApplicationInformationView';
import refereeInfoPageReducer from './ApplicationPage/InformationOfRefereesView';
import documentPageReducer from './ApplicationPage/SupportingDocumentsView';
import importantNotesPageReducer from './ApplicationPage/ImportantNotesView';
import personalParticularsPageReducer from './ApplicationPage/PersonalParticularsView';
import educationBackgroundPageReducer from './ApplicationPage/EducationBackgroundView';
import reviewAndSubmissionPageReducer from './ApplicationPage/ReviewAndSubmissionView';
import applicationStatusPageReducer from './ApplicationPage/ApplicationStatusView';

const rootReducer = history =>
	combineReducers({
		router: connectRouter(history),
		loginPageReducer,
		signUpPageReducer,
		applicationPage: combineReducers({
			applicationInfoPageReducer,
			refereeInfoPageReducer,
			documentPageReducer,
			importantNotesPageReducer,
			personalParticularsPageReducer,
			educationBackgroundPageReducer,
			reviewAndSubmissionPageReducer,
			applicationStatusPageReducer
		})
	});

export default rootReducer;